document,
  addEventListener('turbolinks:load', function () {
    // 配信ページ追加ボタンがクリックされたとき
    document
      .querySelectorAll('.mail_magazine_add_url_button')
      .forEach(function (element) {
        element.addEventListener('click', click_mail_magazine_url);
      });

    function click_mail_magazine_url(e) {
      const mailMagazineUrlsContainer = e.target.closest(
        '.mail_magazine_urls_container'
      );

      const mailMagazineUrlFields = mailMagazineUrlsContainer.querySelectorAll(
        '.url-field'
      );

      let mailMagazineUrlField;

      if (mailMagazineUrlFields.length == 0) {
        mailMagazineUrlField = document.createElement('div');

        mailMagazineUrlField.classList.add('url-field');

        mailMagazineUrlField.innerHTML = `
          <div class="url-field-contents">
            <div class="input-text">
              <input
                placeholder="https://"
                name="mail_magazine[${mailMagazineUrlsContainer.id}][0][name]"
                value=""
                class="field_name"
                type="text"
                id="mail_magazine_${mailMagazineUrlsContainer.id}_name"
              >
            </div>
            <input
              name="mail_magazine[${mailMagazineUrlsContainer.id}][0][m_node_type_id]"
              value="" class="mail_magazine_field_m_node_type_id"
              type="hidden"
              id="mail_magazine_${mailMagazineUrlsContainer.id}_m_node_type_id"
            >
            <input name="mail_magazine[${mailMagazineUrlsContainer.id}][0]"
              value=""
              class="field_mail_magazine_node_id"
              type="hidden"
              id="mail_magazine_${mailMagazineUrlsContainer.id}_mail_magazine_node_id"
            >
            <div class="field-remove">
              <button type="button" class="remove-field btn-remove">
                <svg xmlns="http://www.w3.org/2000/svg" class="icons" viewBox="0 0 448 512">
                  <path fill="currentColor" d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                </svg>
                削除
              </button>
            </div>
      `;
      } else {
        mailMagazineUrlField = mailMagazineUrlFields[0].cloneNode(true);
        mailMagazineUrlField.querySelector('.field_name').value =
          '';
        mailMagazineUrlField.querySelector(
          '.mail_magazine_field_m_node_type_id'
        ).value = '';
        mailMagazineUrlField.querySelector(
          '.field_mail_magazine_node_id'
        ).value = '';
        mailMagazineUrlField.closest('.url-field').style.display =
          'block';
      }

      mailMagazineUrlField
        .querySelector('.remove-field')
        .addEventListener('click', ClickRemove);
      mailMagazineUrlsContainer.appendChild(mailMagazineUrlField);
      reset_m_node_id();
    }

    document
      .querySelectorAll('.remove-field')
      .forEach((element) => {
        element.addEventListener('click', ClickRemove);
      });

    // 削除ボタンが押されたフォームを非表示にして、URLのバリューを空にする
    function ClickRemove(element) {
      element.target.closest('.url-field').style.display = 'none';
      element.target
        .closest('.url-field')
        .querySelector('.field_name').value = '';
      reset_m_node_id();
    }

    // URL欄の数に変更があった時にindexを振り直してname属性を更新する
    function reset_m_node_id() {
      const mailMagazineUrlsContainers = document.querySelectorAll(
        '.mail_magazine_urls_container'
      );

      mailMagazineUrlsContainers.forEach((element, index) => {
        const mailMagazineUrlsContainer = element;
        const mailMagazineUrlFields =
          mailMagazineUrlsContainer.querySelectorAll(
            '.url-field'
          );

        mailMagazineUrlFields.forEach((element, index) => {
          element
            .querySelector('.field_name')
            .setAttribute(
              'name',
              `mail_magazine[${mailMagazineUrlsContainer.id}][${index}][name]`
            );
          element
            .querySelector('.mail_magazine_field_m_node_type_id')
            .setAttribute(
              'name',
              `mail_magazine[${mailMagazineUrlsContainer.id}][${index}][m_node_type_id]`
            );
          element
            .querySelector('.field_mail_magazine_node_id')
            .setAttribute(
              'name',
              `mail_magazine[${mailMagazineUrlsContainer.id}][${index}][mail_magazine_node_id]`
            );
        });
      });
    }
    reset_m_node_id();
  });
